import React from "react";
//import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import './Location.css';
import axios from "axios";
import ReactLoading from 'react-loading';
import LocationOnIcon from '@mui/icons-material/LocationOn';
class Location extends React.Component {
  constructor(){
    super();
    this.state = {
        loc : [],
        pin :[],PinContent:false,list:[],check:''
    }


 
}

  setLocation(district,location, pin){


//alert("ok")
    localStorage.setItem('location', location);
    localStorage.setItem('district', district);
    localStorage.setItem('pin', pin);
    localStorage.setItem('tempPin', pin);
    //const textFromStorage = localStorage.getItem('my-key');
   
    
  }
  async pinResult(e, keyword){
    //alert(keyword.length)
   var pincode = localStorage.getItem('pin')

   if(pincode){
    this.setState({pin:localStorage.getItem('pin')})
    //this.setState({PinContent:true})
    
   }
   else{
    this.setState({pin:keyword})
   }

    
    if (keyword.length > 1){
        
        this.setState({loading:<ReactLoading type="bars" color="#000" height={50} width={35} /> })
        axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.pin_search?pin=' + keyword,{
            headers : {'content-type': 'application/json'}
        })
        .then(response=>{
          this.setState({list:response.data.message})
          let getLocation = response.data.message;
          if(keyword.length === 6){
            const myBtn = document.getElementById('my-btn')
            //alert("ok")
            //alert(getLocation[0]['pin_code'])
            this.setLocation(getLocation[0]['district'],getLocation[0]['location'],getLocation[0]['pin_code'])
            myBtn.click()

          }
          else{
         // console.log(response.data.message)
           if(this.state.pin){
                this.setState({PinContent:true})
           }
           else{
                 this.setState({PinContent:false})
           }
           if (this.state.list.length===0){
            this.setState({check:'We do not deliver in this location'})
             //alert("Not found")
           }
           else{
            this.setState({check:''})
           }
          }
         })
         .catch(
            
          err =>{ console.log(err)
            alert("not found")
          }
          )
    }
    else{
        this.setState({PinContent:false})
    }
    
  }
  
  render() {
    var pincode = localStorage.getItem('pin')
    return <div>
  
  <div className="container ">

      <div className="text-center p-1">
            <a className="" href="/#"> <img src="/assets/images/logo/logo.jpg" alt="" title="" className="mb-4" width="100px" /> </a><br/>
            <p className=""><LocationOnIcon/>Choose your location</p>
            
            <form>
            
            <input  className="loc-srch-btn"  onChange={e => this.pinResult(e, e.target.value)} placeholder="Search your pincode..." defaultValue={pincode}/>
  
            </form>
            {this.state.PinContent ? this.state.list.map((itm,k)=>{

                                        return(  
             <a  key={k} href="" type="button" className="my-lcn-btn btnn" id="my-btn" onClick={(e) =>this.setLocation(itm.district,itm.location, itm.pin_code)}>{itm.location ? itm.location +' ('+itm.pin_code+')' : '' }</a>     
            )
          }) : '' }
<p>{this.state.check}</p>
                                     
            </div>


  </div>


    </div>
    }
}

export default Location;
